export const ACTION_START_EXAM_SESSION = 'ACTION_START_EXAM_SESSION'
export const ACTION_SET_STATUS = 'ACTION_SET_STATUS'
export const ACTION_GET_QUESTION = 'ACTION_GET_QUESTION'
export const ACTION_SAVE_ANSWER = 'ACTION_SAVE_ANSWER'
export const ACTION_START_COUNTDOWN = 'ACTION_START_COUNTDOWN'
export const ACTION_GET_EXAM_STATUS = 'ACTION_GET_EXAM_STATUS'
